export class CompleteProducts extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['header', 'indicator', 'number', 'trigger', 'bundle']
  }

  connectedCallback () {
    super.connectedCallback()

    this.setHeaderHeight()
  }

  setupListeners () {
    super.setupListeners()

    this.onTriggerClick = this.onTriggerClick.bind(this)

    this.els.trigger.elements.forEach(trigger => {
      this.listeners.add(trigger, 'click', this.onTriggerClick)
    })

    this.listeners.add(
      this.els.select.element,
      'click',
      this.onSelectClick.bind(this),
    )
  }

  onTriggerClick (event) {
    const currentActiveTrigger = Array.from(this.els.trigger.elements).find(
      trigger => trigger.getAttribute('aria-current') === 'true',
    )
    const currentActiveBundle = this.els.bundle.elements.find(
      bundle => bundle.getAttribute('aria-hidden') === 'false',
    )

    const newActiveTrigger = event.currentTarget
    const newActiveBundle = this.els.bundle.elements.find(
      bundle =>
        bundle.getAttribute('data-number') ===
        newActiveTrigger.getAttribute('data-number'),
    )

    if (
      currentActiveTrigger === newActiveTrigger &&
      currentActiveBundle === newActiveBundle
    ) {
      return
    }

    currentActiveTrigger.setAttribute('aria-current', 'false')
    currentActiveBundle.setAttribute('aria-hidden', 'true')
    newActiveBundle.setAttribute('aria-hidden', 'false')

    this.els.indicator.element.textContent = newActiveTrigger.dataset.name
    this.els.number.element.textContent = newActiveTrigger.dataset.number

    setTimeout(() => {
      newActiveTrigger.setAttribute('aria-current', 'true')
    }, 300)

    this.els.header.element.setAttribute('aria-expanded', 'false')
  }

  onSelectClick () {
    this.els.header.element.setAttribute(
      'aria-expanded',
      this.els.header.element.getAttribute('aria-expanded') === 'true'
        ? 'false'
        : 'true',
    )
  }

  setHeaderHeight () {
    const headerHeight = this.els.header.element.offsetHeight
    this.style.setProperty(
      '--Sticky_Benefits_Header_Height',
      `${headerHeight}px`,
    )
  }
}

if (!customElements.get('complete-products')) {
  customElements.define('complete-products', CompleteProducts)
}
